// Implements: F-UIX-020
/**
 * The profile scopes the listing answers (W2l): how a row is keyed and named.
 *
 * Nothing here decides what the person may do: `may_edit` is the server's own
 * `policy.may_edit` (P6-OD-16), read as it comes. A scope is keyed by its kind
 * and id, so two scopes of different kinds never collide (checklist 14). A team
 * or an organization is named by the `display_name` the server answers for it
 * (the name `identity` holds, also for a team the session holds no seat in);
 * only one the server cannot name falls back to the start of its id.
 */

import type { ScopeKeyView, ScopeStateView } from "../../../types/design";
import { PLATFORM_LOCALE } from "../../../types/locale";

export function scopeKey(scope: ScopeKeyView): string {
  return `${scope.scope_kind}:${scope.scope_id}`;
}

/** The words of the three scope kinds, in the person's language. */
export interface ScopeWords {
  readonly personal: string;
  readonly team: string;
  readonly organization: string;
}

/** How many characters of an id name a scope the server cannot name. */
const ID_PREFIX = 8;

export function scopeLabel(scope: ScopeStateView, words: ScopeWords): string {
  if (scope.scope_kind === "personal") return words.personal;
  const word = scope.scope_kind === "team" ? words.team : words.organization;
  return `${word} ${scope.display_name ?? scope.scope_id.slice(0, ID_PREFIX)}`;
}

/** Scope names as one phrase ("Personal y Organización Valtx"), as the mockup's list says them. */
export function joinScopes(labels: readonly string[]): string {
  return new Intl.ListFormat(PLATFORM_LOCALE, { style: "long", type: "conjunction" }).format(labels);
}
